import HomePage from './HomePage'
import LoginPage from './LoginPage';
import Modal from 'react-modal';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, PrivateRoute } from './oktaContext';
import Callback from './oktaCallback';
import AccessInstructionsPage from './AccessInstructionsPage';


// Set the app element for react-modal
Modal.setAppElement('#root');

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" Component={LoginPage} />
          <Route path="/callback" Component={Callback} />
          {/* <PrivateRoute path="/home" component={HomePage} /> */}
          <Route path="/home" element={<PrivateRoute component={HomePage} />} />
          <Route path="/accessInstructions" element={<AccessInstructionsPage></AccessInstructionsPage>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
